import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// 아이콘 컴포넌트 (MeetingRoom 톤 그대로: stroke 기반/중심 안정)
const ComputerInfoIcon = ({ type }) => {
  return (
    <div className={`computer_info_icon type_${type}`}>
      {type === 'capacity' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <circle cx="8" cy="9" r="3" />
          <circle cx="16" cy="9" r="3" />
          <path d="M4 18c0-2.2 1.8-4 4-4s4 1.8 4 4" />
          <path d="M12 18c0-2.2 1.8-4 4-4s4 1.8 4 4" />
        </svg>
      )}
      {type === 'equip' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="3" y="5" width="18" height="12" rx="2" />
          <line x1="3" y1="13" x2="21" y2="13" />
          <rect x="9" y="18" width="6" height="2" />
        </svg>
      )}
      {type === 'contact' && (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 4h3l2 4-2 1c.8 2 2.2 3.4 4.2 4.2l1-2 4 2v3c0 1-1 2-2 2C10.5 18.8 5.2 13.5 4 6c0-1 1-2 2-2z" />
        </svg>
      )}
    </div>
  );
};

// 카드 컴포넌트
const ComputerRoomCard = ({ building, roomName, roomDetail, imageClass, infoList }) => {
  const navigate = useNavigate();

  const handleReserve = () => {
    navigate('/board/facility/write', { state: { step: 1 } });
  };

  return (
    <div className="computer_room_block">
      {/* 좌측 이미지 */}
      <div className="computer_img_group">
        <div className={`computer_img ${imageClass}`} />
      </div>

      {/* 우측 */}
      <div className="computer_text_area">
        <div className="computer_top_row">
          {/* 왼쪽: 배지 + 호실명 */}
          <div className="computer_title_group">
            <span className="computer_building">{building}</span>
            <span className="computer_roomname">{roomName}</span>
          </div>

          {/* 오른쪽: pill + 버튼 */}
          <div className="computer_top_right">
            <span className="computer_room_detail">{roomDetail}</span>
            <button type="button" className="computer_apply_btn" onClick={handleReserve}>
              신청하기
            </button>
          </div>
        </div>

        {/* 정보 패널 */}
        <div className="computer_info_panel">
          {infoList.map((item, idx) => (
            <div className="computer_info_item" key={idx}>
              <ComputerInfoIcon type={item.type} />
              <div className="computer_info_text">{item.text}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const Computer = () => {
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  const handleSelect = (num) => setSelect((prev) => (prev === num ? 0 : num));
  const moveBoard = (cate) => navigate(`/board/${cate}`, { state: { cate } });
  const movePage = (path) => navigate(path);
  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area computer">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub" />
              {'> '}보유시설{' > '}전산실습실
            </div>
            <div className="banner_main_text">전산실습실</div>
          </div>
        </div>

        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">보유시설</div>
              <div className="navi_arrow" />
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => moveBoard('notice')}>
                  알림 및 소식
                </div>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  사업분야
                </div>
                <div className="select_row" onClick={() => movePage('/inquiryinfo')}>
                  기업연구동
                </div>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  보유시설
                </div>
                <div className="select_row" onClick={() => movePage('/vision')}>
                  융합원소개
                </div>
              </div>
            </div>

            <div className="navi_box" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">전산실습실</div>
              <div className="navi_arrow" />
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/meetingroom')}>
                  회의실
                </div>
                <div className="select_row" onClick={() => movePage('/computer')}>
                  전산실습실
                </div>
                <div className="select_row" onClick={() => movePage('/printing')}>
                  3D프린터
                </div>
                <div className="select_row" onClick={() => movePage('/arvr')}>
                  AR/VR
                </div>
                <div className="select_row" onClick={() => movePage('/cnc')}>
                  CNC/MCT
                </div>
                <div className="select_row" onClick={() => navigate('/board/facility/write', { state: { step: 1 } })}>
                  시설예약
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sub_main_area computer">
          <aside className="intro_aside_fixed">
            <div className="intro_aside_header">
              <div className="center_box">
                <span>보유시설</span>
                <div className="center_line" />
              </div>
            </div>

            <ul className="intro_aside_list">
              <li className={`intro_aside_item ${isActive('/meetingroom')}`} onClick={() => movePage('/meetingroom')}>
                <span>회의실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/computer')}`} onClick={() => movePage('/computer')}>
                <span>전산실습실</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/printing')}`} onClick={() => movePage('/printing')}>
                <span>3D프린터</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/arvr')}`} onClick={() => movePage('/arvr')}>
                <span>AR / VR</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li className={`intro_aside_item ${isActive('/cnc')}`} onClick={() => movePage('/cnc')}>
                <span>CNC / MCT</span>
                <span className="aside_arrow">&gt;</span>
              </li>
              <li
                className={`intro_aside_item ${isActive('/board/facility/write')}`}
                onClick={() => movePage('/board/facility/write')}
              >
                <span>시설예약</span>
                <span className="aside_arrow">&gt;</span>
              </li>
            </ul>
          </aside>

          <div className="meeting_section_back meetingroom">
            <div className="meeting_section_container">
              <div className="vision_title_box">
                <div className="logo_box">
                  <div className="logo_img" />
                </div>
                <div className="title_text">보유시설 - 전산실습실</div>
              </div>

              <ComputerRoomCard
                building="일반강의실"
                roomName="206호"
                roomDetail="206호 일반강의실"
                imageClass="computer-room-image1"
                infoList={[
                  { type: 'equip', text: '주요 시설: 데스크톱, 전자교탁, 빔프로젝터, 마이크' },
                  { type: 'contact', text: '사용문의: 041-354-8558' },
                ]}
              />

              <ComputerRoomCard
                building="전산실습실"
                roomName="207호"
                roomDetail="207호 전산실습실"
                imageClass="computer-room-image2"
                infoList={[
                  { type: 'capacity', text: '최대 수용인원: 30명' },
                  { type: 'equip', text: '주요 시설: 데스크톱 PC, 3D 설계 교육 장비, 전자교탁, 빔프로젝터, 마이크' },
                  { type: 'contact', text: '사용문의: 041-354-8558' },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Computer;
